import { useState } from 'react';
import { useAuthStore } from '@stores/auth.store';
import { useTenantClassesSubjectsScreen } from './useTenantClassesSubjectsScreen';
import { useBadgeManagement } from './useBadgeManagement';
import { useModuleLimit } from '@hooks/tenant/useModuleLimit';

/**
 * Shell state for Classes & Badge: tab + classes screen + badge management screen.
 */
export function useClassesSubjectsShell() {
    const tenantId = useAuthStore((s) => s.user?.tenantId);
    const classesScreen = useTenantClassesSubjectsScreen({ tenantId });
    const badgeScreen = useBadgeManagement({ tenantId });
    const [activeTab, setActiveTab] = useState('classes');

    const classesCount = classesScreen.classes?.length || 0;
    const { exceeded: classesLimitExceeded } = useModuleLimit({ moduleKey: 'classes', currentCount: classesCount });

    const badgesCount = badgeScreen.allBadges?.length || 0;
    const { exceeded: badgesLimitExceeded } = useModuleLimit({ moduleKey: 'badges', currentCount: badgesCount });

    const { campusPickList, branchOptions, branchTableFilter, setBranchTableFilter, openCreateClass } = classesScreen;

    return {
        activeTab,
        setActiveTab,
        classesScreen,
        badgeScreen,
        classesCampusPickList: campusPickList,
        classesBranchOptions: branchOptions,
        classesBranchTableFilter: branchTableFilter,
        setClassesBranchTableFilter: setBranchTableFilter,
        openCreateClass,
        classesLimitExceeded,
        badgesLimitExceeded,
    };
}
